var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.463 2.94707L8.98087 18.6904L0.839567 12.5046L0.839621 12.5046L0.833719 12.5003C0.238545 12.0705 0.125675 11.2325 0.572039 10.6145C1.00125 10.0202 1.8373 9.9068 2.45508 10.3508L8.09029 14.6287L8.34435 14.8215L8.52129 14.5561L17.2461 1.46894C17.6556 0.854726 18.4956 0.667832 19.0843 1.09303L19.0842 1.09321L19.0936 1.09945C19.7078 1.50892 19.8947 2.34895 19.4695 2.93769L19.4693 2.93756L19.463 2.94707Z",
    fill: "#2E8B57",
    stroke: "#E4E7E6",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckgreen);
export default __webpack_public_path__ + "static/media/checkgreen.c4ae9f29c7eb7f3d036c27be4ddee247.svg";
export { ForwardRef as ReactComponent };